export { SocialLinkedin as default } from './SocialLinkedin';
